import {
  REQUEST_WEB_CARDS,
  DELETE_WEB_CARD,
  REQUEST_WEB_CARD,
  UPDATE_WEB_CARD,
  CREATE_WEB_CARD,
  SORT_WEB_CARD,
} from '../actionTypes';

export const webCardsGet = () => ({
  type: REQUEST_WEB_CARDS,
});

export const webCardGet = (id) => ({
  type: REQUEST_WEB_CARD,
  payload: id,
});

export const webCardDelete = (id) => ({
  type: DELETE_WEB_CARD,
  payload: id,
});

export const webCardUpdate = (id, data) => ({
  type: UPDATE_WEB_CARD,
  payload: { id, data },
});

export const webCardCreate = (data) => ({
  type: CREATE_WEB_CARD,
  payload: data,
});

export const webCardSort = (oldIndex, newIndex) => ({
  type: SORT_WEB_CARD,
  payload: { oldIndex, newIndex },
});
